import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMarker: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="marker,highlight"><path d="M16.75 1.75L3.75 11.75L11.75 19.75L21.75 6.75L16.75 1.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4.25 13.75C3.75 15.75 3.25 17.25 1.75 18.75L4.75 21.75C6.25 20.25 7.75 19.75 9.75 19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconMarker;
